import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'y42-context-menu-refresh',
  templateUrl: './context-menu-refresh.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuRefreshComponent {
  @Output()
  refreshClick = new EventEmitter();
}
